import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ReactNode, useState } from 'react';

interface IProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  defaultExpanded?: boolean;
  children: ReactNode;
}

/**
 * Accordion-Wrapper für „erweiterte Einstellungen" — schlanker und visuell
 * zurückhaltender als die rohe Accordion-API. Die Sektion startet
 * standardmäßig zugeklappt, damit der Standardfall übersichtlich bleibt.
 */
export const CollapsibleSection: React.FC<IProps> = ({
  title,
  subtitle,
  icon,
  defaultExpanded = false,
  children,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, v) => setExpanded(v)}
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        '&::before': { display: 'none' },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction='row' spacing={1} alignItems='center'>
          {icon}
          <Stack>
            <Typography variant='subtitle2' fontWeight={600}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant='caption' color='text.secondary'>
                {subtitle}
              </Typography>
            )}
          </Stack>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
